import React from 'react'
import './tool.css'
import Seperator from '../../Common/Seperator/Seperator'
import { ToolData } from "../../data/Tools"

const Tool = () => {

  const data = ToolData;

  return (
    <div className='tool'>
      <div className="t-cont">
      <div data-aos="fade-up" className="c-title"><Seperator/> <h2>What I Work With</h2> <Seperator/></div>
      <div data-aos="fade-up" className="slider-cont1">Tools that help me turn <br/> your ideas into reality.</div>
      <div className="t-tools">
        {data.map((item) => {
          return (
            <div data-aos="fade-up" className='t-icons' > 
              <div className='t-icon'> {item.icon} </div>
            </div>
          )
        })}
      </div>
      </div>
    </div>
  )
}

export default Tool